var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0906 0.36377H1.32381C0.808966 0.36377 0.391602 0.751129 0.391602 1.22896V3.54826C0.391602 4.02609 0.808966 4.41345 1.32381 4.41345H19.0906C19.6055 4.41345 20.0228 4.02609 20.0228 3.54826V1.22896C20.0228 0.751129 19.6055 0.36377 19.0906 0.36377Z",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3223 10.5203H1.32381C0.806787 10.5203 0.391602 10.135 0.391602 9.65514V7.32857C0.391602 6.84872 0.806787 6.46338 1.32381 6.46338H19.8896",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3223 16.533H1.32381C0.806787 16.533 0.391602 16.1477 0.391602 15.6678V13.3413C0.391602 12.8614 0.806787 12.4761 1.32381 12.4761H12.3223",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4568 8.42676H15.7614C15.1297 8.42676 14.6177 8.90201 14.6177 9.48825V22.5752C14.6177 23.1614 15.1297 23.6367 15.7614 23.6367H24.4568C25.0884 23.6367 25.6005 23.1614 25.6005 22.5752V9.48825C25.6005 8.90201 25.0884 8.42676 24.4568 8.42676Z",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55371 2.91544C2.85223 2.91544 3.09423 2.69084 3.09423 2.41378C3.09423 2.13671 2.85223 1.91211 2.55371 1.91211C2.25518 1.91211 2.01318 2.13671 2.01318 2.41378C2.01318 2.69084 2.25518 2.91544 2.55371 2.91544Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71582 2.91544C5.01434 2.91544 5.25634 2.69084 5.25634 2.41378C5.25634 2.13671 5.01434 1.91211 4.71582 1.91211C4.41729 1.91211 4.17529 2.13671 4.17529 2.41378C4.17529 2.69084 4.41729 2.91544 4.71582 2.91544Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55371 9.01554C2.85223 9.01554 3.09423 8.79094 3.09423 8.51387C3.09423 8.23681 2.85223 8.01221 2.55371 8.01221C2.25518 8.01221 2.01318 8.23681 2.01318 8.51387C2.01318 8.79094 2.25518 9.01554 2.55371 9.01554Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71582 9.01554C5.01434 9.01554 5.25634 8.79094 5.25634 8.51387C5.25634 8.23681 5.01434 8.01221 4.71582 8.01221C4.41729 8.01221 4.17529 8.23681 4.17529 8.51387C4.17529 8.79094 4.41729 9.01554 4.71582 9.01554Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55371 15.1156C2.85223 15.1156 3.09423 14.891 3.09423 14.614C3.09423 14.3369 2.85223 14.1123 2.55371 14.1123C2.25518 14.1123 2.01318 14.3369 2.01318 14.614C2.01318 14.891 2.25518 15.1156 2.55371 15.1156Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71582 15.1156C5.01434 15.1156 5.25634 14.891 5.25634 14.614C5.25634 14.3369 5.01434 14.1123 4.71582 14.1123C4.41729 14.1123 4.17529 14.3369 4.17529 14.614C4.17529 14.891 4.41729 15.1156 4.71582 15.1156Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0203 18.0309C19.3806 17.8709 19.7801 17.7837 20.2032 17.7837C20.6262 17.7837 21.057 17.8782 21.4252 18.0454",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7798 13.7486C17.8138 13.2833 18.9811 13.0288 20.2031 13.0288C21.4252 13.0288 22.6315 13.2978 23.6813 13.7704",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9155 15.9296C18.6049 15.6242 19.3804 15.4497 20.203 15.4497C21.0255 15.4497 21.8245 15.6315 22.5296 15.9441",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2031 21.1281C20.6487 21.1281 21.01 20.7928 21.01 20.3792C21.01 19.9656 20.6487 19.6304 20.2031 19.6304C19.7575 19.6304 19.3962 19.9656 19.3962 20.3792C19.3962 20.7928 19.7575 21.1281 20.2031 21.1281Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/DevicesIcon.51d679ad06a5bade7951f036d5a40766.svg";
export { ForwardRef as ReactComponent };